import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TourHeader = ({ tour }) => {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [isShared, setIsShared] = useState(false);

  const handleWishlist = () => {
    setIsWishlisted(!isWishlisted);
  };

  const handleShare = () => {
    setIsShared(true);
    navigator.clipboard?.writeText(window.location?.href);
    setTimeout(() => setIsShared(false), 2000);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        className={index < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}
      />
    ));
  };

  return (
    <div className="bg-white">
      {/* Breadcrumb */}
      <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-4">
        <span>Home</span>
        <Icon name="ChevronRight" size={14} />
        <span>{tour?.destination}</span>
        <Icon name="ChevronRight" size={14} />
        <span className="text-foreground">{tour?.name}</span>
      </div>
      {/* Main Header */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-6">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="bg-primary/10 text-primary px-2 py-1 rounded-full text-xs font-medium">
              {tour?.category}
            </span>
            {tour?.isPopular && (
              <span className="bg-accent/10 text-accent px-2 py-1 rounded-full text-xs font-medium">
                Popular Choice
              </span>
            )}
            {tour?.instantBooking && (
              <span className="bg-success/10 text-success px-2 py-1 rounded-full text-xs font-medium">
                Instant Booking
              </span>
            )}
          </div>

          <h1 className="text-2xl lg:text-3xl font-bold text-foreground mb-3">
            {tour?.name}
          </h1>

          <div className="flex flex-wrap items-center gap-4 text-sm">
            {/* Rating */}
            <div className="flex items-center space-x-1">
              <div className="flex items-center">
                {renderStars(tour?.rating)}
              </div>
              <span className="font-medium">{tour?.rating}</span>
              <span className="text-muted-foreground">({tour?.reviewCount} reviews)</span>
            </div>

            {/* Location */}
            <div className="flex items-center space-x-1 text-muted-foreground">
              <Icon name="MapPin" size={16} />
              <span>{tour?.location}</span>
            </div>

            {/* Duration */}
            <div className="flex items-center space-x-1 text-muted-foreground">
              <Icon name="Clock" size={16} />
              <span>{tour?.duration}</span>
            </div>

            {/* Group Size */}
            <div className="flex items-center space-x-1 text-muted-foreground">
              <Icon name="Users" size={16} />
              <span>Max {tour?.maxGroupSize} people</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleShare}
            iconName={isShared ? "Check" : "Share"}
            iconPosition="left"
          >
            {isShared ? "Copied!" : "Share"}
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={handleWishlist}
            iconName={isWishlisted ? "Heart" : "Heart"}
            iconPosition="left"
            className={isWishlisted ? "text-red-500" : ""}
          >
            {isWishlisted ? "Saved" : "Save"}
          </Button>
        </div>
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-muted/30 rounded-lg">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{tour?.totalBookings}+</div>
          <div className="text-sm text-muted-foreground">Bookings</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{tour?.languages?.length}</div>
          <div className="text-sm text-muted-foreground">Languages</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{tour?.cancellationPolicy}</div>
          <div className="text-sm text-muted-foreground">Cancellation</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{tour?.difficulty}</div>
          <div className="text-sm text-muted-foreground">Difficulty</div>
        </div>
      </div>
    </div>
  );
};

export default TourHeader;